import React from "react";

import { FormFieldErrorMessage } from "~/components/form/error-message";
import { FormLabel } from "~/components/form/label";
import { FormFieldReset } from "~/components/form/reset";

import { Widget, WidgetBody, WidgetHeader } from "../../../_widget";
import { WidgetCalculationField } from "../../../widget-form/calculation";
import { WidgetDecimalsField } from "../../../widget-form/decimals";
import { WidgetFontSizeField } from "../../../widget-form/font-size";
import { WidgetMetricLabelField } from "../../../widget-form/metric-label";
import { WidgetSparklineField } from "../../../widget-form/sparkline";
import { WidgetUnitField } from "../../../widget-form/unit";
import { SettingsSectionFormField } from "../_field";
import { ResetToDefaultSection } from "../_reset-to-default-section";
import { SettingsSectionGrid } from "../_section-grid";
import { ThresholdsSection } from "../_thresholds/section";

import { FormState } from "./form-state";

export interface StatChartSettingsProps {
	settings: FormState;
}

export const StatChartSettings: React.FC<StatChartSettingsProps> = ({ settings }) => (
	<div className="grid h-full grid-cols-3 gap-4">
		<Widget>
			<WidgetHeader className="uppercase" title="Misc">
				<FormFieldReset
					className="ml-auto"
					state={[
						settings.fields.sparkline,
						settings.fields.unit,
						settings.fields.decimals,
						settings.fields.calculation,
						settings.fields.metricLabel,
						settings.fields.fontSize,
					]}
				/>
			</WidgetHeader>

			<WidgetBody card>
				<SettingsSectionGrid className="grid-cols-[auto_1fr]">
					<SettingsSectionFormField layout="horizontal" state={settings.fields.sparkline}>
						<FormLabel>Sparkline</FormLabel>
						<WidgetSparklineField name="dashboard-widget-misc-sparkline" sparkline={settings.fields.sparkline} />
					</SettingsSectionFormField>

					<SettingsSectionFormField layout="horizontal" state={settings.fields.unit}>
						<FormLabel>Unit</FormLabel>
						<WidgetUnitField className="w-full" default={undefined} unit={settings.fields.unit} />
					</SettingsSectionFormField>

					<SettingsSectionFormField layout="horizontal" state={settings.fields.decimals}>
						<FormLabel>Decimals</FormLabel>
						<WidgetDecimalsField decimals={settings.fields.decimals} name="dashboard-widget-settings-decimal-places" />
						<FormFieldErrorMessage className="col-span-full" />
					</SettingsSectionFormField>

					<SettingsSectionFormField layout="horizontal" state={settings.fields.calculation}>
						<FormLabel>Calculation</FormLabel>
						<WidgetCalculationField calculation={settings.fields.calculation} name="dashboard-widget-misc-calculated" />
					</SettingsSectionFormField>

					<SettingsSectionFormField layout="horizontal" state={settings.fields.metricLabel}>
						<FormLabel>Metric Label</FormLabel>
						<WidgetMetricLabelField
							metricLabel={settings.fields.metricLabel}
							name="dashboard-widget-misc-metric-label"
						/>
					</SettingsSectionFormField>

					<SettingsSectionFormField layout="horizontal" state={settings.fields.fontSize}>
						<FormLabel>Font Size</FormLabel>
						<WidgetFontSizeField fontSize={settings.fields.fontSize} name="dashboard-widget-misc-value-font-size" />
						<FormFieldErrorMessage className="col-span-full" />
					</SettingsSectionFormField>
				</SettingsSectionGrid>
			</WidgetBody>
		</Widget>

		<div className="flex flex-col gap-4">
			<Widget>
				<WidgetHeader className="uppercase" title="Thresholds">
					<FormFieldReset className="ml-auto" state={[settings.fields.color, settings.fields.thresholds]} />
				</WidgetHeader>

				<WidgetBody card>
					<ThresholdsSection defaultColor={settings.fields.color} thresholds={settings.fields.thresholds} />
				</WidgetBody>
			</Widget>

			<ResetToDefaultSection onClick={() => FormState.resetToDefault(settings)} />
		</div>
	</div>
);
